import * as actions from './actionsTypes';

const initialData = {
  loader: false,
  loaderWorkFlowBlocksM: false,
  loaderWorkFlowBlock: false,
  saveLoader: false,
  workflowBlockLength: 0,
  workflowBlocksLengthM: 0,
  workflowBlocks: [],
  workflowBlocksM: [],
  workflowBlock: null,
  formErrors: '',
  error: '',
  errorM: ''
}

export default function workflowBlockReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_WORKFLOWBLOCK:
      return {...state, loaderWorkFlowBlock: action.payload}
    case actions.LOADING_WORKFLOWBLOCKSM:
      return {...state, loaderWorkFlowBlocksM: action.payload}
    case actions.LOADING_WORKFLOWBLOCKS:
      return {...state, loader: action.payload}
    case actions.SAVE_LOADING_WORKFLOWBLOCK:
      return {...state, saveLoader: action.payload}
    case actions.GET_WORKFLOWBLOCKS:
      return {...state, workflowBlocks: action.payload.workflowBlocks, workflowBlockLength: action.payload.workflowBlockLength}
    case actions.GET_WORKFLOWBLOCKSM:
      return {...state, workflowBlocksM: action.payload.workflowBlocksM, workflowBlocksLengthM: action.payload.workflowBlocksLengthM}
    case actions.GET_WORKFLOWBLOCK:
      return {...state, workflowBlock: action.payload}
    case actions.WORKFLOWBLOCK_FAIL:
      return {...state, error: action.payload}
    case actions.WORKFLOWBLOCK_FAILM:
      return {...state, error: action.payload}
    case actions.WORKFLOWBLOCK_FORM_FAIL:
      return {...state, formErrors: action.payload}
    default:
      return state
  }
}